import { useState, useContext } from "react";
import { Navigate } from "react-router";
import { UserContext } from "../UserContext";
import TextEditor from "../Editor";
import config from "../config";

export default function CreatePage() {
  const { userInfo } = useContext(UserContext);

  const [title, setTitle] = useState("");
  const [summary, setSummary] = useState("");
  const [content, setContent] = useState("");
  const [files, setFiles] = useState("");
  const [redirect, setRedirect] = useState("");

  async function createNewPost(event) {
    const data = new FormData();
    data.set("title", title);
    data.set("summary", summary);
    data.set("content", content);
    data.set("files", files[0]);

    event.preventDefault();
    const response = await fetch(`${config.apiUrl}/create`, {
      method: "POST",
      body: data,
      credentials: "include",
    });

    if (response.ok) {
      setRedirect(true);
    } else {
      response
        .json()
        .then((errorData) => {
          alert(errorData.error || "An error occurred");
        })
        .catch((error) => {
          console.error("Failed to parse JSON", error);
          alert("An unexpected error occurred");
        });
    }
  }

  if (redirect) {
    return <Navigate to={"/"} />;
  }
  const privelages = userInfo?.isAdmin;

  return (
    <>
      {!privelages && <h1>You don't have acces to those resources</h1>}
      {privelages && (
        <form className="create" onSubmit={createNewPost}>
          <h1>Crete new post</h1>
          <input
            type="text"
            placeholder={"Title"}
            value={title}
            onChange={(ev) => setTitle(ev.target.value)}
          />
          <input
            type="text"
            placeholder={"Summary"}
            value={summary}
            onChange={(ev) => setSummary(ev.target.value)}
          />
          <input type="file" onChange={(ev) => setFiles(ev.target.files)} />

          <TextEditor content={content} setContent={setContent} />
          <button className="forms-button">
            <span>Create Post</span>
          </button>
        </form>
      )}
    </>
  );
}
